import { useAppStore } from '../store';

export const useIsLightColorScheme = (): boolean => {
  const theme = useAppStore((state) => state.theme);
  return theme === 'light';
};
